import { render, staticRenderFns } from "./loading_base_test.vue?vue&type=template&id=9607652e&scoped=true&"
import script from "./loading_base_test.vue?vue&type=script&lang=js&"
export * from "./loading_base_test.vue?vue&type=script&lang=js&"
import style0 from "./loading_base_test.vue?vue&type=style&index=0&id=9607652e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9607652e",
  null
  
)

export default component.exports